import { useState } from 'react';
import { Ruler } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { PrivateImage } from '@/components/studio/PrivateImage';

const NAMES = { front: 'Vorne', back: 'Hinten' };

export const DraftViews = ({ draft, alt, testId }) => {
  const views = Object.entries(draft.view_renders || {});
  if (views.length < 2) return <PrivateImage id={draft.render_id} alt={alt} testId={testId} />;
  return <div className="draft-views" data-testid={`${testId}-views`}>{views.map(([view, id]) => <figure key={view}><PrivateImage id={id} alt={`${alt} · ${NAMES[view] || view}`} testId={`${testId}-${view}`} /><figcaption>{NAMES[view] || view}</figcaption></figure>)}</div>;
};

const cm = v => v ? `${String(v).replace('.', ',')} cm` : '–';

export const SizeChart = ({ sizes, testId }) => {
  const [open, setOpen] = useState(false);
  if (!sizes?.some(s => s.width_cm || s.length_cm)) return null;
  return <>
    <button type="button" className="size-chart-link" onClick={() => setOpen(true)} data-testid={`${testId}-open`}><Ruler size={13} />Größentabelle</button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="size-chart-dialog" data-testid={`${testId}-dialog`}>
      <DialogHeader><DialogTitle>Größentabelle</DialogTitle><DialogDescription>Maße des flach liegenden Shirts. Tipp: Miss ein Shirt, das dir gut passt, und vergleiche.</DialogDescription></DialogHeader>
      <table className="size-chart-table" data-testid={`${testId}-table`}><thead><tr><th>Größe</th><th>Breite (Brust)</th><th>Länge</th></tr></thead>
        <tbody>{sizes.map(s => <tr key={s.name} data-testid={`${testId}-row-${s.name}`}><th>{s.name}</th><td>{cm(s.width_cm)}</td><td>{cm(s.length_cm)}</td></tr>)}</tbody></table>
    </DialogContent></Dialog>
  </>;
};
